import http from 'superagent'

export default class DesktopNotificationsService {


    sendTestNotification() {
        let authToken = webase.model.auth_token
        let baseUrl = webase.utils.app.getBaseUrl()

        let url = baseUrl + '/api/v1/users/push-subscription.json?t=' + Date.now()

        http.post(url)
            .send({})
            .set('x-api-token', authToken)
            .set('Accept', 'application/json')
            .end((error, response) => {

                if (response.status === 200 || response.status === 201) {
                    console.log('Test successful')
                } else {
                    console.log('Test failed')
                }
            })
    }

    enableNotifications() {
        let authToken = webase.model.auth_token
        let baseUrl = webase.utils.app.getBaseUrl()

        navigator.serviceWorker.ready
            .then((serviceWorkerRegistration) => {
                serviceWorkerRegistration.pushManager.getSubscription()
                    .then((subscription) => {

                        let model = {
                            subscription: subscription.toJSON()
                        }

                        let url = baseUrl + '/api/v1/users/push-subscription.json?t=' + Date.now()

                        http.post(url)
                            .send(model)
                            .set('x-api-token', authToken)
                            .set('Accept', 'application/json')
                            .end((error, response) => {

                                if (response.status === 200 || response.status === 201) {
                                    console.log('Subscribe successful')
                                    webase.model.currentUser.push_enabled = true
                                    // resolve(JSON.parse(response.text))
                                } else {
                                    console.log('Subscribe failed')
                                    // reject(JSON.parse(response.text))
                                }
                            })
                    });
            });
    }

}